// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_tooltip-container__Ay1qM {
  position: relative;
  width: fit-content;
}
.Tooltip_tooltip-container__content__rZvsh {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Tooltip_tooltip-container__tooltip__3mb5O {
  position: absolute;
  background-color: #172b4d;
  color: var(--m-white);
  min-width: min-content;
  max-width: 300px;
  width: max-content;
  height: fit-content;
  overflow: hidden;
  z-index: var(--m-z-index-tooltip);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  display: none;
}
.Tooltip_tooltip-container__tooltip--bottom__PA1Gi {
  bottom: 0;
  margin-bottom: -5px;
  transform: translate(0, 100%);
}
.Tooltip_tooltip-container__tooltip--top__rcVKc {
  top: 0;
  margin-top: -5px;
  transform: translate(0, -100%);
}
.Tooltip_tooltip-container__tooltip--left__CEeSZ {
  left: 0;
  transform: translate(calc(-100% - 5px), 0);
}
.Tooltip_tooltip-container__tooltip--right__bYLbU {
  right: 0;
  transform: translate(calc(100% + 5px), 0);
}

[m-data-theme=dark] .Tooltip_tooltip-container__tooltip__3mb5O {
  background-color: #A0ADBB;
  color: #162949;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Tooltip/Tooltip.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAGA,kBAAA;AACJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAGI;EACI,kBAAA;EACA,yBAAA;EACA,qBAAA;EAGA,sBAAA;EACA,gBAAA;EAGA,kBAAA;EAGA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AADR;AAGQ;EACI,SAAA;EACA,mBAAA;EACA,6BAAA;AADZ;AAIQ;EACI,MAAA;EACA,gBAAA;EACA,8BAAA;AAFZ;AAKQ;EACI,OAAA;EACA,0CAAA;AAHZ;AAMQ;EACI,QAAA;EACA,yCAAA;AAJZ;;AAWQ;EACI,yBAAA;EACA,cAAA;AARZ","sourcesContent":[".tooltip-container {\n    position: relative;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n\n\n    &__content {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &__tooltip {\n        position: absolute;\n        background-color: #172b4d;\n        color: var(--m-white);\n        min-width: -webkit-min-content;\n        min-width: -moz-min-content;\n        min-width: min-content;\n        max-width: 300px;\n        width: -webkit-max-content;\n        width: -moz-max-content;\n        width: max-content;\n        height: -webkit-fit-content;\n        height: -moz-fit-content;\n        height: fit-content;\n        overflow: hidden;\n        z-index: var(--m-z-index-tooltip);\n        padding: 1px 6px;\n        border-radius: 4px;\n        font-size: 12px;\n        border: 1px solid transparent;\n        display: flex;\n        align-items: center;\n        display: none;\n\n        &--bottom {\n            bottom: 0;\n            margin-bottom: -5px;\n            transform: translate(0, 100%);\n        }\n    \n        &--top {\n            top: 0;\n            margin-top: -5px;\n            transform: translate(0, -100%);\n        }\n    \n        &--left {\n            left: 0;\n            transform: translate(calc(-100% - 5px), 0);\n        }\n    \n        &--right {\n            right: 0;\n            transform: translate(calc(100% + 5px), 0);\n        }\n    }\n}\n\n[m-data-theme=\"dark\"] {\n    .tooltip-container {\n        &__tooltip {\n            background-color: #A0ADBB;\n            color: #162949;\n        }\n    } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip-container": `Tooltip_tooltip-container__Ay1qM`,
	"tooltip-container__content": `Tooltip_tooltip-container__content__rZvsh`,
	"tooltip-container__tooltip": `Tooltip_tooltip-container__tooltip__3mb5O`,
	"tooltip-container__tooltip--bottom": `Tooltip_tooltip-container__tooltip--bottom__PA1Gi`,
	"tooltip-container__tooltip--top": `Tooltip_tooltip-container__tooltip--top__rcVKc`,
	"tooltip-container__tooltip--left": `Tooltip_tooltip-container__tooltip--left__CEeSZ`,
	"tooltip-container__tooltip--right": `Tooltip_tooltip-container__tooltip--right__bYLbU`
};
export default ___CSS_LOADER_EXPORT___;
